define('modules/audiences/onboarding/main',["T1Module"], function (T1Module) {
  "use strict";

  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "audiences/onboarding",
      viewCfgs: {
        onboarding: {},
        createEdit: {
          model: null
        }
      },
      defaultView: "onboarding"
    });
  }
  return instance;
});
